import { shallowRef } from 'vue';
import { apiRequest, errorMessage } from '@/api/http';
import { useToast } from './useToast';

// Copies a section's class periods from its last school year with any into
// the selected year (and, in a year graded in terms, the chosen term). Periods that couldn't be copied (a teacher booked
// elsewhere, an archived account) come back in `skipped`, for the page to
// list in a dialog.
//   const { copying, skipped, skippedOpen, copy } = useCopySchedule();
//   if (await copy(sectionId, yearId, term)) reload();
export function useCopySchedule() {
  const toast = useToast();
  const copying = shallowRef(false);
  const skipped = shallowRef([]);
  const skippedOpen = shallowRef(false);

  async function copy(roomId, schoolYearId, term = null) {
    copying.value = true;
    try {
      const body = await apiRequest('post', '/enroll-student/copySchedule', { roomId, schoolYearId, term: term || null });
      if (Number(body?.status) === 404) {
        toast.info(body.msg);
        return false;
      }
      if (Number(body?.status) !== 201) toast.error(body?.msg || 'Could not copy the schedule.');
      else if (body.copied) toast.success(body.msg);
      skipped.value = body?.skipped ?? [];
      if (skipped.value.length) skippedOpen.value = true;
      return !!body?.copied;
    } catch (e) {
      toast.error(errorMessage(e, 'Could not copy the schedule.'));
      return false;
    } finally {
      copying.value = false;
    }
  }

  return { copying, skipped, skippedOpen, copy };
}
